import { combineReducers } from 'redux';
import loading from './loading';
import error from './error';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as formReducer } from 'redux-form';
import authReducer from './authReducer';

export default combineReducers({
  // loading,
  // error,
  toastr: toastrReducer,
  // form: formReducer,
  auth: authReducer
});
